(() => {
  if (window.__selleasyCartGoalWidgetNormalizer) return;
  window.__selleasyCartGoalWidgetNormalizer = true;

  const DRAWER_SELECTOR = '#CartDrawer';
  const SLOT_ID = 'CartDrawer-AppGoalSlot';
  const SLOT_SELECTOR = '[data-selleasy-cart-goal-slot], #CartDrawer-AppGoalSlot';
  const WIDGET_SELECTOR = '.tl-custom-cart-goal-container';
  let normalizeQueued = false;

  function getSlot(drawer) {
    if (!drawer) return null;

    let slot = drawer.querySelector(SLOT_SELECTOR);
    if (slot) return slot;

    const itemsScroll = drawer.querySelector('.cart-drawer__items-scroll');
    if (!itemsScroll) return null;

    slot = document.createElement('div');
    slot.id = SLOT_ID;
    slot.className = 'cart-drawer__selleasy-goal-slot';
    slot.setAttribute('data-selleasy-cart-goal-slot', '');
    itemsScroll.before(slot);

    return slot;
  }

  function hasContent(widget) {
    return Boolean(widget?.children?.length || widget?.textContent?.trim());
  }

  function normalizeWidget() {
    const drawer = document.querySelector(DRAWER_SELECTOR);
    const slot = getSlot(drawer);

    if (!drawer || !slot) return;

    const widgets = Array.from(drawer.querySelectorAll(WIDGET_SELECTOR));
    if (!widgets.length) return;

    const widgetsOutsideSlot = widgets.filter((widget) => !slot.contains(widget));
    const populatedOutsideSlot = widgetsOutsideSlot.filter(hasContent);
    const populatedInsideSlot = Array.from(slot.querySelectorAll(WIDGET_SELECTOR)).find(hasContent);
    const primaryWidget =
      populatedOutsideSlot[populatedOutsideSlot.length - 1] ||
      populatedInsideSlot ||
      widgetsOutsideSlot[widgetsOutsideSlot.length - 1] ||
      widgets[0];

    if (!primaryWidget) return;

    if (primaryWidget.parentElement !== slot) {
      slot.appendChild(primaryWidget);
    }

    Array.from(drawer.querySelectorAll(WIDGET_SELECTOR)).forEach((widget) => {
      if (widget !== primaryWidget) widget.remove();
    });
  }

  function scheduleNormalizeWidget() {
    if (normalizeQueued) return;

    normalizeQueued = true;
    requestAnimationFrame(() => {
      normalizeQueued = false;
      normalizeWidget();
    });
  }

  function isRelevantNode(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return false;

    return (
      node.matches?.(`${DRAWER_SELECTOR}, ${SLOT_SELECTOR}, ${WIDGET_SELECTOR}`) ||
      node.querySelector?.(`${DRAWER_SELECTOR}, ${SLOT_SELECTOR}, ${WIDGET_SELECTOR}`)
    );
  }

  const observer = new MutationObserver((mutations) => {
    const shouldNormalize = mutations.some((mutation) => Array.from(mutation.addedNodes).some(isRelevantNode));

    if (shouldNormalize) scheduleNormalizeWidget();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.body?.addEventListener('cart:refresh', scheduleNormalizeWidget);
  scheduleNormalizeWidget();
})();
